import { render, staticRenderFns } from "./statisticsPatients.vue?vue&type=template&id=7fd4133c"
import script from "./statisticsPatients.vue?vue&type=script&lang=js"
export * from "./statisticsPatients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports